const mapStyle = [
    {
      featureType: "administrative",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
        {
          lightness: 33,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f2e5d4",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#c5dac6",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "labels",
      stylers: [
        {
          visibility: "on",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [
        {
          color: "#c5c6c6",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#e4d7c6",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#fbfaf7",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#acbcc9",
        },
      ],
    },
  ];
  
  
  
  
  
  function initMap() {
    // Create the map.
    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 5,
      center: { lat: 33.6384373, lng: -101.885752 },
      styles: mapStyle,
    });
  
  
  
    map.data.addGeoJson(storeData, { idPropertyName: "storeid" });
  

  
  
    const apiKey = "AIzaSyBuycmxR4sCnvifR2R_P3Ne4462FrMV02s";
    const infoWindow = new google.maps.InfoWindow();
  
    // Show the information for a store when its marker is clicked.
    map.data.addListener("click", (event) => {
      const category = event.feature.getProperty("category");
      const name = event.feature.getProperty("name");
      const description = event.feature.getProperty("description");
      const state = event.feature.getProperty("state");
      const manager = event.feature.getProperty("manager");
      const job = event.feature.getProperty("job");
      const street = event.feature.getProperty("street");
      const address = event.feature.getProperty("address");
      const zipCode = event.feature.getProperty("zip-code");
      const mail = event.feature.getProperty("mail");
      const linkId = name.replace(/\s/g, '');
      const phone = event.feature.getProperty("phone");
      const position = event.feature.getGeometry().get();
      const content = `
          <div class="point-information" style="padding: 20px;max-width:300px;">
            <h3 class="city-name">${name}</h3>, <span>${state}</span>
            <p><a class="map-link" href="#${linkId}">Link to store</a><br/><br/>
            
            ${street}<br/>
            ${name}, ${zipCode}<br/>
            </p>
            <p class="mapPopupLink"></p>
            
          </div>
          `;
  
      infoWindow.setContent(content);
      infoWindow.setPosition(position);
      infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
      infoWindow.open(map);
  
  
  
    });
  
    // Build and add the search bar
    const card = document.createElement("div");
    const titleBar = document.createElement("div");
    const title = document.createElement("div");
    const container = document.createElement("div");
    const input = document.createElement("input");
    const options = {
      types: ["postal_code"],
      componentRestrictions: { country: "us" },
    };
  
    card.setAttribute("id", "pac-card");
    title.setAttribute("id", "title");
    title.textContent = "Find the nearest store";
    titleBar.appendChild(title);
    container.setAttribute("id", "pac-container");
    input.setAttribute("id", "pac-input");
    input.setAttribute("type", "text");
    input.setAttribute("placeholder", "Enter Your ZIP Code");
    container.appendChild(input);
    card.appendChild(titleBar);
    card.appendChild(container);
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);
  
    // Make the search bar into a Places Autocomplete search bar and select
    // which detail fields should be returned about the place that
    // the user selects from the suggestions.
    const autocomplete = new google.maps.places.Autocomplete(input, options);
  
    autocomplete.setFields(["address_components", "geometry", "name"]);
  
    // Set the origin point when the user selects an address
    const originMarker = new google.maps.Marker({ map: map });
    originMarker.setVisible(false);
    let originLocation = map.getCenter();
  
    autocomplete.addListener("place_changed", async () => {
      originMarker.setVisible(false);
      originLocation = map.getCenter();
      const place = autocomplete.getPlace();
  
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No address available for input: '" + place.name + "'");
        return;
      }
  
      // Recenter the map to the selected address
      originLocation = place.geometry.location;
      map.setCenter(originLocation);
      map.setZoom(9);
      
  
      originMarker.setPosition(originLocation);
      originMarker.setVisible(true);
  
      // Use the selected address as the origin to calculate distances
      // to each of the store locations
      const rankedStores = await calculateDistances(map.data, originLocation);
     
      showStoresList(map.data, rankedStores);
  
      return;
    });
  
    async function calculateDistances(data, origin) {
      const stores = [];
      const destinations = [];
      const stores_2 = [];
      const destinations_2 = [];
  
      // Build parallel arrays for the store IDs and destinations

   


      let i = 0;
      data.forEach((store) => {
        i++
        const storeNum = store.getProperty("storeid");
        const storeLoc = store.getGeometry().get();

        if (i < 24) {
          stores.push(storeNum);
          destinations.push(storeLoc);
        } 
        if (i > 23) {
          stores_2.push(storeNum);
          destinations_2.push(storeLoc);
        } 
        


      });
  
      // console.log('stores',stores)
      // console.log('stores-2',stores_2)
      // console.log('destinations',destinations)
      // console.log('destinations_2',destinations_2)
      
      // Retrieve the distances of each store from the origin
      // The returned list will be in the same order as the destinations list
      const service = new google.maps.DistanceMatrixService();
      // const service_2 = new google.maps.DistanceMatrixService();
  

      const getDistanceMatrix = (service, parameters) =>
        new Promise((resolve, reject) => {
          service.getDistanceMatrix(parameters, (response, status) => {
            if (status != google.maps.DistanceMatrixStatus.OK) {
              reject(response);
            } else {
              const distances = [];
              const results = response.rows[0].elements;
              for (let j = 0; j < results.length; j++) {
          
                const element = results[j];
  
               
  
                const distanceText = element.distance.text;
                const distanceVal = element.distance.value;
                const distanceObject = {
                  storeid: stores[j],
                  distanceText: distanceText,
                  distanceVal: distanceVal,
                };
                distances.push(distanceObject);
              }
              console.log('distances',distances)
              resolve(distances);
            }
          });
        });


        // const distancesList_2 = await getDistanceMatrix(service_2, {
        //   origins: [origin],
        //   destinations: destinations_2,
        //   travelMode: "DRIVING",
        //   unitSystem: google.maps.UnitSystem.METRIC,
        // });

  
      const distancesList = await getDistanceMatrix(service, {
        origins: [origin],
        destinations: destinations,
        travelMode: "DRIVING",
        unitSystem: google.maps.UnitSystem.METRIC,
      });

      // const allDistances = [...distancesList, ...distancesList_2];
      // console.log('allDistances',allDistances)


  
      distancesList.sort((first, second) => {
        return first.distanceVal - second.distanceVal;
      });
  
      return distancesList;
    }
  
    function showStoresList(data, stores) {
      if (stores.length == 0) {
        console.log("empty stores");
        return;
      }
  
      let panel = document.createElement("div");
      // If the panel already exists, use it. Else, create it and add to the page.
  
        const closeEl = document.createElement('div');
        closeEl.setAttribute('id', 'closeIcon');
        closeEl.innerHTML = 'X';
        panel.appendChild(closeEl);
  
      if (document.getElementById("panel")) {
        panel = document.getElementById("panel");
        // If panel is already open, close it
        if (panel.classList.contains("open")) {
          panel.classList.remove("open");
        }
      } else {
        panel.setAttribute("id", "panel");
        const body = document.body;
        body.insertBefore(panel, body.childNodes[0]);
      }
  
  
  
  
  
      // Clear the previous details
      while (panel.lastChild) {
        panel.removeChild(panel.lastChild);
        //panel.appendChild(closeEl);
        
      }
  
      stores.forEach((store) => {
        // Add store details with text formatting
        const name = document.createElement("p");
        name.classList.add("place");
        const currentStore = data.getFeatureById(store.storeid);
        name.textContent = currentStore.getProperty("name") + " (" + currentStore.getProperty("state") + ")";
  
        let storeName = currentStore.getProperty("name");
        let userObj = JSON.parse(sessionStorage.getItem('userObj'));
        const cutomersSpan = document.createElement("span");
        cutomersSpan.classList.add("customers-side");
  
    
        if(typeof userObj[storeName] !== "undefined" ) {
          cutomersSpan.textContent = `Customers: ${userObj[storeName]}`;
        }
  
        const surrentLink = "#" + currentStore.getProperty("name").replace(/\s/g, '');
  
        const storeLink = document.createElement('a');
        storeLink.setAttribute('class', 'panelLink');
        const createAText = document.createTextNode("See Information");
        storeLink.setAttribute('href', surrentLink);
        storeLink.appendChild(createAText);
  
        panel.appendChild(name);
        
        const distanceText = document.createElement("p");
        distanceText.classList.add("distanceText");
        distanceText.textContent = store.distanceText;
        panel.appendChild(distanceText);
       
        panel.appendChild(storeLink);
        panel.appendChild(cutomersSpan);
  
  
  
        let href = currentStore.getProperty("name").replace(/\s/g, '');
        let titleArray = document.querySelectorAll('.state-point');
        let storeContainer = document.getElementById(href);
  
        storeLink.addEventListener('click', function(e) {
          e.preventDefault();
  
          titleArray.forEach(function(el) {
              el.classList.remove('active');
              
          });
  
         
          storeContainer.classList.add('active');
  
  
          while (panel.lastChild) {
            panel.removeChild(panel.lastChild);      
          }
          panel.classList.remove("open");
  
  
  
          const scrollTarget = document.getElementById(href);
          //const topOffset = document.querySelector('.scrollto').offsetHeight;
          const topOffset = 220; // если не нужен отступ сверху 
          const elementPosition = scrollTarget.getBoundingClientRect().top;
          const offsetPosition = elementPosition - topOffset;
  
          window.scrollBy({
              top: offsetPosition,
              behavior: 'smooth'
          });
  
        });
  
        // console.log('href ',href);
        // console.log('titleArray ',titleArray);
        // console.log('storeLink ',storeLink);
      });
  
  
  
  
      panel.appendChild(closeEl);
      // Open the panel
      panel.classList.add("open");
  
      if (document.getElementById("closeIcon")) {
        document.getElementById("closeIcon").addEventListener('click', function() {
          while (panel.lastChild) {
            panel.removeChild(panel.lastChild);      
          }
          panel.classList.remove("open");
        })
      }
  
    
      return;
    }
  
  };
  